var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadImageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0V20.0803H12.9967V18H3.08951L3 2L10 2V7H14.9967V10.8427L16.9967 9.42134V4.5L12 0H1ZM11.6519 2.93422L14.4353 5.13793H11.6519V2.93422ZM16 12.7241L13.0345 16H15L14.9967 20H16.9967V16H19L16 12.7241Z",
    fill: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04698 8C6.8556 8 6.67207 8.07902 6.53675 8.21967C6.40142 8.36032 6.3254 8.55109 6.3254 8.75C6.3254 8.94891 6.40142 9.13968 6.53675 9.28033C6.67207 9.42098 6.8556 9.5 7.04698 9.5C7.23835 9.5 7.42189 9.42098 7.55721 9.28033C7.69253 9.13968 7.76856 8.94891 7.76856 8.75C7.76856 8.55109 7.69253 8.36032 7.55721 8.21967C7.42189 8.07902 7.23835 8 7.04698 8ZM10.2941 10.25L7.76856 13.25L5.96461 11.375L4 14H13L10.2941 10.25Z",
    fill: "#2A2A2A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImageIcon);
export default __webpack_public_path__ + "static/media/upload_image_icon.af8f0f3f.svg";
export { ForwardRef as ReactComponent };